// Injects all JSON-LD structured data into <head>. Implemented as a composable
// (not a rendered component) so it adds NO DOM node — an empty-template component
// renders a comment on the client but nothing on the server during prerender,
// which shifts the app-root children by one and breaks hydration on every page.
export function useSeoStructuredData() {
// JSON-LD Structured Data for SEO
// Includes Organization, LocalBusiness and WebSite schemas. Each page adds its
// own BreadcrumbList, and each service page its own Service, via useStructuredData.


const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': 'https://augmentblu.co.uk/#organization',
  name: 'AugmentBLU',
  url: 'https://augmentblu.co.uk',
  logo: 'https://augmentblu.co.uk/ab_logo.png',
  description: 'Edinburgh-based Laravel specialists delivering enterprise web applications, CMS migrations, and Vue.js frontends.',
  foundingDate: '2009',
  sameAs: [
    'https://www.linkedin.com/company/augmentblu/'
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'sales',
    email: 'hello@augmentblu.co.uk',
    availableLanguage: ['English']
  },
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Edinburgh',
    addressRegion: 'Scotland',
    addressCountry: 'GB'
  }
}

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  '@id': 'https://augmentblu.co.uk/#localbusiness',
  name: 'AugmentBLU',
  image: 'https://augmentblu.co.uk/ab_logo.png',
  url: 'https://augmentblu.co.uk',
  email: 'hello@augmentblu.co.uk',
  description: 'Laravel development and CMS migration specialists based in Edinburgh, Scotland. Enterprise web applications, Vue.js frontends, and ongoing support.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Edinburgh',
    addressRegion: 'Scotland',
    addressCountry: 'GB'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 55.9533,
    longitude: -3.1883
  },
  areaServed: [
    {
      '@type': 'Country',
      name: 'United Kingdom'
    },
    {
      '@type': 'Place',
      name: 'Worldwide'
    }
  ],
  priceRange: '££££',
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '09:00',
    closes: '18:00'
  }
}

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': 'https://augmentblu.co.uk/#website',
  url: 'https://augmentblu.co.uk',
  name: 'AugmentBLU',
  description: 'Laravel Development & CMS Migration Specialists',
  publisher: {
    '@id': 'https://augmentblu.co.uk/#organization'
  },
  inLanguage: 'en-GB'
}

// Combine all schemas
const staticSchemas = [
  organizationSchema,
  localBusinessSchema,
  webSiteSchema,
]

useHead(() => ({
  script: [
    ...staticSchemas.map(schema => ({
      type: 'application/ld+json',
      innerHTML: JSON.stringify(schema),
    })),
  ],
}))
}
